/* eslint-disable @typescript-eslint/no-type-alias */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "StickyContext", {
    enumerable: true,
    get: function() {
        return StickyContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const StickyContext = /*#__PURE__*/ _react.default.createContext({
    push: ()=>({
            ref: {
                current: null
            },
            top: 0,
            stack: false
        }),
    pop: ()=>undefined,
    stack: {
        current: []
    },
    rootRef: null
});

//# sourceMappingURL=StickyContext.js.map